<span class="tooltip-icon">
  <ng-container *ngIf="tooltip || template; else elseTemplate">
    <xux-icon
    [icon]="icon"
    [tooltip]="(tooltip | translate) || popTemplate"
    [placement]="placement"
    [container]="container"
    [containerClass]="containerClass"
    [ngClass]="class"
    [isOpen]="isOpen"
    ></xux-icon>
  </ng-container>
  <ng-template #elseTemplate>
    <xux-icon [icon]="icon" [ngClass]="class"></xux-icon>
  </ng-template>
</span>

<ng-template #popTemplate><div [innerHtml]="sanitizeHTMLStringValue(template) | translate"></div></ng-template>
